export const handleSortQueryParams = (selectedSortOption) => {
  if (!selectedSortOption) return;

  const isNativeSortOption = !!selectedSortOption?.sort_by;
  // if currently selectedSortOption is a  native sort option (such as Popular and Price), add sortBy and sortOrder
  if (isNativeSortOption) {
    return {
      sortBy: selectedSortOption?.sort_by,
      sortOrder: selectedSortOption?.sort_order,
    };
  }

  // if currently selectedSortOption is NOT a native sort option (a recently_released facet), add recently_released to queryParams
  return { recently_released: selectedSortOption.value };
};
